import PropTypes from 'prop-types'
import styled from 'astroturf/react'
import { PaymentAmount } from '@calendly/booking-kit'

import { useI18n } from 'locales'
import _Spacing from "info-Spacing.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/payment/info.js?styleId=Spacing";


const Spacing = /*#__PURE__*/styled('div', null, {
  displayName: "Spacing",
  styles: _Spacing
})

const Info = ({ amountWithSymbol, currency, paymentTerms = null }) => {
  const { i18n } = useI18n()
  return (
    <Spacing>
      <strong>{i18n.t('booking.templates.payment.price')}</strong>
      <PaymentAmount
        amount={amountWithSymbol}
        currencyCode={currency}
      />
      {paymentTerms && (
        <Spacing>
          <strong>{i18n.t('booking.templates.payment.payment_terms')}</strong>
          <div>{paymentTerms}</div>
        </Spacing>
      )}
    </Spacing>
  )
}

Info.propTypes = {
  amountWithSymbol: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  paymentTerms: PropTypes.string
}

export default Info
